<div class="modal-dialog copy-previous-assignment-dialog-container">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="copy-previous-assignment-modal_title" [id]="dialogTitleId"></h4>
      <button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body" #content>
      <ng-container [formGroup]="form">
        <mat-form-field appearance="outline">
          <mat-label translate="copy-previous-assignment-modal_choose-course"></mat-label>
          <mat-select
            formControlName="folder"
            id="folder-selector"
            disableOptionCentering
            [placeholder]="'copy-previous-assignment-modal_no-courses' | translate"
            panelClass="offsetPanel">
            @for (folder of courses$ | async; track folder) {
              <mat-option [value]="folder.group_id">
                {{ folder.name }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          @if (form.controls.folder.hasError('required')) {
            <mat-error>{{'copy-previous-assignment-modal_choose-course-error' | translate}}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label translate="copy-previous-assignment-modal_choose-assignment"></mat-label>
          <mat-select
            formControlName="activity"
            id="activity-selector"
            disableOptionCentering
            [placeholder]="'copy-previous-assignment-modal_no-assignments' | translate"
            panelClass="offsetPanel">
            @for (activity of assignments$ | async; track activity) {
              <mat-option [value]="activity">
                {{ activity.name }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          @if (form.controls.activity.hasError('required')) {
            <mat-error>{{'copy-previous-assignment-modal_choose-assignment-error' | translate}}</mat-error>
          }
        </mat-form-field>
      </ng-container>
    </div>
    <div class="goreact-modal-footer">
      <button
        type="button"
        class="cancel-btn tertiary-btn"
        (click)="cancel()">
        {{'common_cancel' | translate}}
      </button>
      <button
        class="confirm-button primary-btn"
        (click)="confirm()"
        [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
        translate="common_add">
      </button>
    </div>
  </div>
</div>
